<div class="main">
  <app-menu></app-menu>
  <div class="container">
    <app-header></app-header>
    <div class="content">
      <ng-content></ng-content>
    </div>
    <app-footer></app-footer>
  </div>
</div>
